<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import {
		resolveEnergyConditionSummary,
		resolveFlowNodeTypeLabel,
	} from '../../helpers/flowNodeCardPresentation';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: displayText = resolveEnergyConditionSummary(data);
	$: nodeTypeLabel = resolveFlowNodeTypeLabel('energyCondition', data);
</script>

<BaseConditionNode
	{id}
	type="energyCondition"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={displayText}
	{nodeTypeLabel}
	badge="Business"
	{...$$restProps}
/>
